import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  Cancel,
  DateIcon,
  SingleProfile,
} from "../../../styled/AllImages";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  TextStyled,
  TextWithIcon,
} from "../../../styled/Elements";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import AddSingleUser from "../../../common/modals/singleUserModal/AddSingleUser";
import { toast } from "react-toastify";

const SelectUserModal = ({
  show,
  onHide,
  title,
  createdBy,
  editHistory,
  transferHistory,
  usersList,
  onSave, // Callback to save data in the parent component
  onUserAdd,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [selectedUser, setSelectedUser] = useState(null); // Store the selected user
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;
  

  const handleUserAdd = (user) => {
    setSelectedUser(user); // Ensure selectedUser is updated with the selected user data
  };
  const handleSelectUser = (user) => {
    onUserAdd(user); // Pass the selected user to the parent
  };
  const handleSave = () => {
    if (selectedUser) {
      const userObj = usersList.find(
        (user) => parseInt(user.id) === parseInt(selectedUser)
      );

      const userData = {
        id: userObj.id,
        user: {
          name: userObj.name,
          subLabel: userObj.subLabel,
          userBranch: userObj.userBranch,
          image: `${ASSET_URL}/${userObj.profile}`
        },
        startDate,
        endDate,
      };

      onSave(userData); // Pass the user data to the parent component
      onHide(); // Close the modal after saving
      
    } else {
      toast.error(t('no_user_selected'));
    }
  };

  const customDateFormat = (date) => {
    return format(date, "yyyy-MM-dd"); // 'Wed, 25 June'
  };

  return (
    <Modal size="lg" show={show} onHide={onHide} centered>
      <SelectUserModalWrapper>
        <Box className="">
          <Box className="d-flex justify-content-between align-items-center border-bottom p-4">
            <HeadingStyled size="24px" weight="bold" color="var(--text)">
              {t("Assignuserstemporary")}
            </HeadingStyled>
            <Cancel
              className="cursor-pointer"
              style={{ height: "20px", width: "20px" }}
              onClick={onHide}
            />
          </Box>

          <Box>
            <section>
              <Box className="table-responsive">
                <table>
                  <tr>
                    <td>
                      <TextStyled size="14px" color="var(--text2)">
                        {t("SelectUser")}
                      </TextStyled>
                    </td>
                    <td>
                      <Box className="aaa">
                        <AddSingleUser
                          title="add_user"
                          icon={<SingleProfile />}
                          selPlaceholder="add_user"
                          mainParents={usersList}
                          setSelectedItem={handleUserAdd}
                        />
                      </Box>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TextStyled size="14px" color="var(--text2)">
                        {t("startDate")}
                      </TextStyled>
                    </td>
                    <td>
                      <Box className="d-flex gap-2 align-items-center">
                        <Box className="rangeIconText">
                          <TextWithIcon icon={DateIcon} />
                        </Box>

                        <Box className="rangeInner">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            minDate={new Date()}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            dateFormat="yyyy-MM-dd"
                            customInput={
                              <input
                                value={endDate ? customDateFormat(endDate) : ""}
                                readOnly
                              />
                            }
                          />
                        </Box>
                      </Box>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TextStyled size="14px" color="var(--text2)">
                        {t("endDate")}
                      </TextStyled>
                    </td>
                    <td>
                      <Box className="d-flex gap-2 align-items-center">
                        <Box className="rangeIconText">
                          <TextWithIcon icon={DateIcon} />
                        </Box>
                        <Box className="rangeInner">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            dateFormat="yyyy-MM-dd"
                            customInput={
                              <input
                                value={endDate ? customDateFormat(endDate) : ""}
                                readOnly
                              />
                            }
                          />
                        </Box>
                      </Box>
                    </td>
                  </tr>
                </table>
              </Box>
            </section>
          </Box>
        </Box>
      </SelectUserModalWrapper>
      <Box className="modal-footer">
        <ButtonStyled
          label={t("Cancel")}
          onClick={onHide}
          bg="var(--bgSecondary)"
          color="var(--text2)"
        />

        <ButtonStyled
          type="button"
          bg="var(--themeColor)"
          label={t("Save")}
          onClick={handleSave}
          // onClick={handleAddUserClick} // Only add the user when the Add button is clicked
        />
      </Box>
    </Modal>
  );
};

export default SelectUserModal;

const SelectUserModalWrapper = styled.div`
  .react-datepicker-wrapper {
    input {
      width: 100%;
      color: var(--text);
      font-size: 14px;
      border: none;
      padding-top: 2px;
      cursor: pointer;
      &:focus {
        border: none;
        box-shadow: none;
        outline: none;
      }
    }
  }
  .rangeIconText .mx-2 {
    margin: 0 !important;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0 0px;
    tr {
      td {
        &:first-child {
          max-width: 200px;
          width: 200px;
        }
        border-bottom: 1px solid var(--borderLight);
        padding: 14px 16px;
        color: var(--text);
        font-size: 14px;
        vertical-align: middle;
      }
      &:last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    td {
      border-radius: 0 !important;
    }
  }
`;
